export default __webpack_public_path__ + "static/media/be-there.83edb106.svg";